import axios from '@hw-core/libs/axios'
import { db, functions, auth } from '@/shared/services/firebase'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReports(ctx, { accountId }) {
      return new Promise((resolve, reject) => {
        db.collection('reports')
          .where('accountId', '==', accountId)
          .orderBy('created', 'desc')
          .get()
          .then(snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return {
                id: item.id,
                areaName: item.areaName,
                totalShifts: item.totalShifts,
                status: item.status,
                start: item.start,
                end: item.end,
                downloadURLS: item.downloadURLS,
                createdBy: item.createdBy,
                created: item.created,
              }
            })
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchAreasForReport(ctx, {
      start, end, accountId, status,
    }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${functions.url}/getAreasForReport`, {
              start,
              end,
              accountId,
              status,
              token: idToken,
            })
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              reject(error)
            })
        }).catch(error => {
          reject(error)
        })
      })
    },

    createReport(ctx, {
      name,
      createdBy,
      start,
      areaId,
      areaName,
      totalShifts,
      end,
      status,
      accountId,
      rpHeaders,
      rpBody,
    }) {
      return new Promise((resolve, reject) => {
        // Return download url of the csv file created
        auth.currentUser.getIdToken(true).then(idToken => {
          axios.post(`${functions.url}/createCsvFile`, {
            fields: rpHeaders,
            rows: rpBody,
            start: new Date(start).toLocaleDateString('fi'),
            end: new Date(end).toLocaleDateString('fi'),
            status,
            name,
            token: idToken,
          }).then(async response => {
            axios.post(`${functions.url}/createReport`, {
              name,
              start,
              end,
              status,
              areaId,
              areaName,
              totalShifts,
              accountId,
              createdBy,
              downloadURL: response.data.url,
              fields: rpHeaders,
              rows: rpBody,
              token: idToken,
            }).then(() => resolve())
              .catch(error => reject(error))
          }).catch(error => reject(error))
        }).catch(error => {
          reject(error)
        })
      })
    },

    deleteReport(ctx, { id }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios.post(`${functions.url}/deleteReport`, { reportId: id, token: idToken })
            .then(() => {
              resolve()
            }).catch(() => {
              reject()
            })
        }).catch(error => {
          reject(error)
        })
      })
    },

    fetchUserDetails(ctx, { assignedTo }) {
      return new Promise((resolve, reject) => {
        db.collection('users').doc(assignedTo)
          .get()
          .then(doc => {
            if (!doc.exists) {
              reject()
            } else {
              resolve(doc.data())
            }
          })
          .catch(() => {
            reject()
          })
      })
    },
  },
}
